import Tabs from './Tabs';
import { ITabList } from './interfaces';

export type { ITabList };
export default Tabs;
